'use client';

import React, { AnchorHTMLAttributes } from 'react';
import ReactMarkdown from 'react-markdown';

import { useToggle } from '@/hooks/use-toggle';
import { useTranslation } from '@/i18n/client';
import { WithLang } from '@/types/general';

export default function CompanyDescription(props: WithLang<{ description: string }>) {
    const { t } = useTranslation(props.lang, 'common');
    const isExpandable = props.description?.length > 150;
    const { toggleValue, handleToggle } = useToggle();
    return (
        <>
            <ReactMarkdown
                className={`md:line-clamp-none ${
                    toggleValue ? '' : 'line-clamp-5'
                } mt-3 flex-col whitespace-pre-wrap text-base leading-7 sm:text-xl`}
                components={{
                    a: CustomLink,
                }}
            >
                {props.description}
            </ReactMarkdown>
            {isExpandable && (
                <button onClick={handleToggle} className="ml-auto block font-bold md:hidden">
                    {toggleValue ? t('collapse') : t('expand')}
                </button>
            )}
        </>
    );
}

const CustomLink = ({ href, children }: AnchorHTMLAttributes<HTMLAnchorElement>) => {
    return (
        <a className="font-semibold text-blue-800" href={href} target="_blank" rel="nofollow">
            {children}
        </a>
    );
};
